export default __webpack_public_path__ + "static/media/logo.58e5d4f4.png";